import {
  PermissionSSORedirectStorage,
} from 'frontcore/domain/authorization/model/PermissionService.d'

const STORAGE_KEY = 'SSORedirect'

export default class PermissionSSORedirectStorageImpl implements PermissionSSORedirectStorage {

  get (): string | null {
    return localStorage.getItem(STORAGE_KEY)
  }
  set () {
    localStorage.setItem(STORAGE_KEY, window.location.pathname)
  }
  clear () {
    localStorage.removeItem(STORAGE_KEY)
  }

}
